<Slide :slide :i>

    <Modal slideIndex={{i}} modalIndex={{0}} modal={{$science_asides.about}} />

    <div class="cta">
        <p class="cta__text">{{$about.cta}}</p>

        <ul class="navbar__social cta__social">
            <li class="navbar__social-item facebook">
                <a target="_blank" rel="noopener" href="http://www.facebook.com/sharer/sharer.php?u={{ $BASE_URL }}">Facebook</a>
            </li>
            <li class="navbar__social-item twitter">
                <a target="_blank" rel="noopener" href="https://twitter.com/intent/tweet?url={{ $BASE_URL }}&text={{ encodeURIComponent($title) }}&via=frontlinepbs">Twitter</a>
            </li>
        </ul>
    </div>

</Slide>

<script>
import Modal from './Modal.html'
import Slide from './Slide.html'

export default {

    components: {
        Modal,
        Slide,
    },
}

</script>